module.exports = __webpack_public_path__ + "static/media/desenhos_diversos3.5fc55393.jpg";